const TAG = {
  DYNAMIC: "chaseanalytics-track-link",
  EXTERNAL: "chaseanalytics-opt-exlnk",
  FORM: " chaseanalytics-track-element"
}

export default TAG
